import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

const CarouselSlider1 = () => {
  const images = [
    {
      id: 1,
      src: "https://i.postimg.cc/T316RMsy/2e03b5c2fdf8699dd46470ba35eabdd6.png",
      alt: "AMIR Logo",
    },
    {
      id: 2,
      src: "https://i.postimg.cc/fLhpS68f/2224b2ba618145b95d870a5ab15a52fa.png",
      alt: "Son-x Logo",
    },
    {
      id: 3,
      src: "https://i.postimg.cc/xTqx8f0S/c82da5209665deda41f1a31988e29bcd.png",
      alt: "My Food Logo",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Auto slide every 3 seconds
  useEffect(() => {
    const autoSlideInterval = setInterval(handleNext, 3000);
    return () => clearInterval(autoSlideInterval); // Cleanup interval on component unmount
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "400px",
        overflow: "hidden",
        padding: "2rem",
      }}
    >
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          color: "green",
          fontWeight: "bold",
          mb: 3, // Margin bottom to give space between heading and carousel
          fontFamily: '"Montserrat", sans-serif',
          textAlign:"center"
        }}
      >
        Our Products are also <br />Available on Below Platforms
      </Typography>

      {/* Carousel Slider */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          height: "300px",
          width: "100%",
        }}
      >
        {/* Left Arrow */}
        <Box
          onClick={handlePrev}
          sx={{
            position: "absolute",
            left: "10px",
            fontSize: "2rem",
            cursor: "pointer",
            color: "green",
            zIndex: 10,
          }}
        >
          &lt;
        </Box>

        {/* Image Container */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          {images.map((image, index) => {
            const position =
              index === currentIndex
                ? 0
                : index === (currentIndex - 1 + images.length) % images.length
                ? -100
                : index === (currentIndex + 1) % images.length
                ? 100
                : 1000; // Push other images off-screen

            // Apply a box highlight to the centered image
            const highlightStyle =
              index === currentIndex
                ? {
                    border: "4px solid #A9C47F", // Highlight with a green box
                    boxShadow: "0px 0px 15px rgba(0, 128, 0, 0.5)",
                  }
                : {};

            return (
              <Box
                key={image.id}
                sx={{
                  position: "absolute",
                  transform: `translateX(${position}%)`,
                  transition: "transform 0.5s ease-in-out",
                  opacity: Math.abs(position) === 1000 ? 0 : 1,
                  width: "300px",
                  height: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "200px",
                    height: "150px",
                    borderRadius: "16px",
                    border: "2px solid #A9C47F",
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    ...highlightStyle, // Apply highlight style if it's the current image
                  }}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                </Box>
              </Box>
            );
          })}
        </Box>

        {/* Right Arrow */}
        <Box
          onClick={handleNext}
          sx={{
            position: "absolute",
            right: "10px",
            fontSize: "2rem",
            cursor: "pointer",
            color: "green",
            zIndex: 10,
          }}
        >
          &gt;
        </Box>
      </Box>
    </Box>
  );
};

export default CarouselSlider1;
